import { ReactElement, ReactNode } from 'react'
import { IconButton, IconButtonProps } from '@mui/material'
import { alpha } from '@mui/material/styles'

interface ActiveIconButtonProps extends IconButtonProps {
  isActive: boolean
  children: ReactNode
}

const ActiveIconButton = ({
  isActive,
  size = 'small',
  children,
  sx,
  ...props
}: ActiveIconButtonProps): ReactElement => {
  const mergedSx = Array.isArray(sx) ? sx : sx ? [sx] : []

  return (
    <IconButton
      {...props}
      size={size}
      aria-pressed={isActive}
      color={isActive ? 'primary' : 'default'}
      sx={[
        ...mergedSx,
        theme => ({
          border: isActive ? `1px solid ${theme.palette.primary.main}` : '1px solid transparent',
          backgroundColor: isActive ? alpha(theme.palette.primary.main, 0.08) : 'transparent',
          transition: 'background-color 120ms ease, border-color 120ms ease, transform 120ms ease',
          '&:hover': {
            backgroundColor: isActive
              ? alpha(theme.palette.primary.main, 0.14)
              : theme.palette.action.hover,
          },
          '& .MuiSvgIcon-root': {
            transition: 'transform 120ms ease',
            transform: isActive ? 'scale(1.12)' : 'scale(1)',
          },
        }),
      ]}
    >
      {children}
    </IconButton>
  )
}

export default ActiveIconButton
